export class CustomerViewModel {
  public uid: string = null;
  public email: string = null;
  public name: string = null;
  public street: string = null;
  public tel: string = null;
  public town: string = null;
  public ecommerce: boolean = false;

  static sample(): CustomerViewModel {
    const cust = new CustomerViewModel();
    cust.uid = `${Math.random()}`;
    cust.name = `name ${cust.uid}`;
    cust.street = `street ${cust.uid}`;
    return cust;
  }
}
